<template>
  <div class="d-flex" id="wrapper">
    <Sidebar :toggler.sync="isToggled" />
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" />
      <div class="card mt-1 no-mobile">
        <div class="table-responsive" v-on:scroll.passive="handleScroll">
          <div class="table-controls m-3">
            <div class="controls-wrap d-flex">
              <!-- Integration Field -->

              <Search
                placeholderText="Search (title and description)"
                @show-filter="toggleFilter = true"
                @close-filter="toggleFilter = false"
                @search="doSearch"
              />

              <button
                class="btn btn-outline mr-4"
                type="button"
                @click="addFilter((input = {}), filters)"
              >
                <i class="fas fa-plus-circle"></i>
              </button>

              <div class="d-flex align-items-start">
                <!-- Published checkbox -->
                <div class="empl">
                  <!--  <input
                  @change="handleSearchFilters"
                  v-model="isPublished"
                  id="published"
                  class="mr-2 custom-control-input"
                  type="checkbox"
                  aria-label
                />
                <label style="white-space: nowrap" class="custom-control-label" for="published"
                  >Published</label
                > -->

                  <v-select
                    @input="handleSearchFilters"
                    v-model="isPublished"
                    placeholder="Status"
                    inputId="published-promoted-select"
                    :options="['Published', 'Promoted']"
                    :reduce="res => res"
                    :clearable="false"
                    multiple
                  ></v-select>
                </div>

                <div class="empl">
                  <v-select
                    @input="handleSearchFilters"
                    v-model="serviceLevelSelectModel"
                    placeholder="Service level"
                    inputId="service-level-select"
                    :options="[
                      { id: 0, service: 'Basic' },
                      { id: 1, service: 'Sourcing' },
                      { id: 2, service: 'Full-service' },
                    ]"
                    label="service"
                    :reduce="res => res"
                    :clearable="false"
                    multiple
                  ></v-select>
                </div>
              </div>

              <!-- Add Job btn -->
              <router-link
                :to="{ name: 'add-job-mobile' }"
                type="button"
                class="ml-auto btn btn-success text-nowrap m-button"
              >
                Add Job
              </router-link>
              <button
                type="button"
                class="ml-auto btn btn-success text-nowrap desktop-only"
                @click="showModal = true"
              >
                Add Job
                <!--             <portal to="add-job-modal">
              <CustomMainModal @close="showModal = false" v-show="showModal">
                <template v-slot:header>
                  <h5>Add Job</h5>
                </template>
                <AddJobBtnModal></AddJobBtnModal>
              </CustomMainModal>
            </portal> -->
              </button>
            </div>

            <!-- FILTERS -->
            <section class="filter-items">
              <div class="row mt-3">
                <div
                  v-for="(input, index) in filters"
                  :key="`phoneInput-${index}`"
                  class="col-md-8 filter"
                >
                  <div class="d-flex">
                    <select
                      @change="selectedFilterType"
                      name="select-filter"
                      class="form-control filter-select"
                      v-model="selectedFilterName[index]"
                    >
                      <option value="location">Location</option>
                      <option value="distance">City (distance)</option>
                      <option value="employment">Employment type</option>
                      <option value="competences">Competencies</option>
                      <option value="relocation">Relocation</option>
                    </select>

                    <v-select
                      v-if="selectedFilterName[index] == 'location'"
                      @input="handleVSelectFields($event, selectedFilterName)"
                      @search="fetchOptions"
                      v-model="input['location']"
                      class="mr-1 w-100"
                      label="name"
                      placeholder="Location"
                      aria-label="location"
                      aria-describedby="location-input"
                      :options="[...locationsOptions]"
                      :reduce="location => location"
                      :clearable="false"
                      multiple
                    >
                      <template v-slot:no-options>
                        <div style="opacity: 0.5">Please type at least 3 characters</div>
                      </template>
                    </v-select>

                    <v-select
                      v-if="selectedFilterName[index] == 'distance'"
                      @change="handleVSelectFields($event, selectedFilterName)"
                      @search="fetchOptionsForCities"
                      v-model="input['city']"
                      class="mr-1 w-100"
                      inputId="city-distance"
                      label="name"
                      placeholder="City name"
                      aria-label="city-distance"
                      aria-describedby="city-distance-input"
                      :options="citiesByNameOptions"
                      :reduce="city => city"
                      :clearable="false"
                      autocorrect="off"
                      spellcheck="false"
                      autocomplete="off"
                    >
                      <template v-slot:no-options>
                        <div style="opacity: 0.5">Please type at least 3 characters</div>
                      </template>
                    </v-select>

                    <input
                      v-if="selectedFilterName[index] == 'distance'"
                      v-model="input['distance']"
                      @input="toggleLabel($event)"
                      type="text"
                      id="distance"
                      name="distance"
                      style="max-width: 145px; min-width: 145px"
                      class="form-control mr-1"
                      aria-describedby="CityDistanceHelp"
                      placeholder="Distance (km)"
                    />

                    <label
                      v-if="selectedFilterName[index] == 'distance' && showLabel"
                      class="custom-label"
                      for="distance"
                      >km</label
                    >

                    <select
                      v-if="selectedFilterName[index] == 'employment'"
                      @input="handleVSelectFields($event, selectedFilterName)"
                      class="form-control w-100"
                      name="employment"
                      v-model="input['employment']"
                    >
                      <option value="1">Employment</option>
                      <option value="2">Self-employment</option>
                      <option value="3">Employment / Self-Employment</option>
                    </select>

                    <v-select
                      v-if="selectedFilterName[index] == 'competences'"
                      @input="handleVSelectFields($event, selectedFilterName)"
                      v-model="input['competences']"
                      class="w-100 mr-1"
                      placeholder="Competencies"
                      label="name"
                      :options="[...getCompetencesFilterList]"
                      :reduce="competence => competence.id"
                      :clearable="false"
                      multiple
                    >
                      <template v-slot:no-options>
                        <div style="opacity: 0.5">Sorry, no matching competence</div>
                      </template>
                    </v-select>

                    <select
                      v-if="selectedFilterName[index] == 'serviceLevel'"
                      class="form-control mr-0"
                      v-model="input['serviceLevel']"
                      @input="handleVSelectFields($event, selectedFilterName)"
                      name="service-level"
                    >
                      <option>Basic</option>
                      <option>Sourcing</option>
                      <option>Full-service</option>
                    </select>

                    <select
                      v-if="selectedFilterName[index] == 'relocation'"
                      @input="handleVSelectFields($event, selectedFilterName)"
                      class="form-control"
                      v-model="input['relocation']"
                      name="relocation"
                    >
                      <option :value="false">No</option>
                      <option :value="true">Yes</option>
                    </select>

                    <button
                      class="btn btn-outline-remove"
                      type="button"
                      @click="removeSingleFilter(index, filters)"
                    >
                      <i class="fas fa-times-circle"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="row" v-show="filters.length > 0">
                <div class="col-md-8 d-flex filter">
                  <div class="ml-auto">
                    <button
                      type="button"
                      class="btn btn-success text-nowrap text-white mt-2 mr-1"
                      @click="applyFilters"
                    >
                      Apply Filters
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger text-nowrap text-white mt-2 mr-1"
                      @click="removeAllFilters"
                    >
                      Remove Filters
                    </button>
                    <button
                      class="btn btn-outline mt-2"
                      type="button"
                      @click="addFilter((input = {}), filters)"
                    >
                      <i class="fas fa-plus-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <!-- END FILTERS -->
          </div>

          <!-- Mobile Interface -->
          <section class="candidate-mobile mt-4 mobile-only">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <ul class="list-unstyled">
                    <li v-for="(jobAd, $index) in infiniteScrollList" :key="$index" class="mb-3">
                      <router-link
                        class="username mb-2"
                        :to="{ name: 'job_uuid', params: { job_uuid: jobAd.uuid } }"
                        >{{ jobAd.title }}</router-link
                      >
                      <div class="d-flex main mb-1">
                        <span>{{ jobAd.employer_id }}</span>
                        <span>8 Hours ago</span>
                      </div>
                      <div class="d-flex mb-2">
                        <span>{{ getLocation(jobAd) }}</span>
                        <span> <span class="status employment"></span> {{ getStatus }} </span>
                      </div>
                      <div class="collapse" id="collapseExample">
                        <ul class="list-inline stats">
                          <li class="list-inline-item w-20"><span>12</span> not contacted</li>
                          <li class="list-inline-item"><span>12</span> contacted</li>
                          <li class="list-inline-item"><span>12</span> Interviewing</li>
                          <li class="list-inline-item"><span>12</span> offered</li>
                          <li class="list-inline-item"><span>12</span> hired</li>
                        </ul>
                      </div>
                      <a
                        class="toggle-collapse"
                        data-toggle="collapse"
                        href="#collapseExample"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseExample"
                      >
                        <i class="fas fa-chevron-down"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <infinite-loading
              @infinite="infiniteHandler"
              force-use-infinite-wrapper="true"
              spinner="waveDots"
            ></infinite-loading>
          </section>
          <!-- End mobile Interface -->

          <Spinner :isLoading="isLoading" />

          <table class="table table-striped custom-table desktop-only-table">
            <thead class="bg-dark">
              <tr>
                <th
                  id="col-title"
                  class="sticky"
                  :style="stylesObj"
                  style="width: 240px"
                  scope="col"
                  nowrap
                >
                  TITLE
                </th>
                <th :style="{ display: isVisible }" nowrap scope="col">EMPLOYER</th>
                <th nowrap style="width: 180px" scope="col">LOCATION</th>
                <th nowrap style="width: 80px; text-align: center" scope="col">&nbsp;</th>
                <th nowrap scope="col">UPDATED</th>
                <th nowrap scope="col">STATUS</th>
                <th nowrap scope="col">PIPELINE STATISTICS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="jobAd in getJobAds" :key="jobAd.uuid">
                <td id="title" nowrap>
                  <div class="truncate-item">
                    <popper
                      trigger="hover"
                      :options="{
                        placement: 'top',
                        modifiers: { offset: { offset: '0,10px' } },
                      }"
                    >
                      <div class="popper">
                        {{ jobAd.title }}
                      </div>
                      <div slot="reference">
                        <router-link
                          :to="{
                            name: 'job_uuid',
                            params: { job_uuid: jobAd.id, job_name: jobAd.title },
                          }"
                        >
                          {{ jobAd.title }}
                        </router-link>
                      </div>
                    </popper>
                  </div>
                </td>
                <td :style="{ display: isVisible }" id="employer" nowrap>
                  <popper
                    trigger="hover"
                    :options="{
                      placement: 'top',
                      modifiers: { offset: { offset: '0,10px' } },
                    }"
                  >
                    <div class="popper">
                      {{ jobAd.employer_name }}
                    </div>
                    <div slot="reference">
                      <router-link
                        :to="{
                          name: 'employer_id',
                          params: {
                            employer_id: jobAd.js_employer_id,
                            employer_name: jobAd.employer_name,
                          },
                        }"
                        >{{ jobAd.employer_name }}</router-link
                      >
                    </div>
                  </popper>
                </td>
                <td id="location" nowrap>
                  {{ getLocation(jobAd) }}
                </td>
                <td id="service-level" class="p-0" nowrap>
                  <div class="popover-show mx-auto" style="width: 25px; height: auto">
                    <svgHelper
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      :title="serviceLevel(jobAd.service_level).title"
                      :name="serviceLevel(jobAd.service_level).title"
                    ></svgHelper>
                  </div>
                </td>

                <td nowrap id="updated-at">
                  <div
                    class="popover-show"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="
                      jobAd.updated_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: true,
                        })
                    "
                  >
                    {{
                      jobAd.updated_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                </td>

                <td id="status" align="center">
                  <div class="d-flex align-items-center">
                    <div
                      :class="[
                        getStatusColorClass(jobAd.status),
                        'flex-shrink-0',
                        'stage-size',
                        'rounded-circle',
                        'mr-2',
                      ]"
                    ></div>
                    <span
                      :class="[
                        getStatusTitle(jobAd.status).status !== '' ? 'text-nowrap' : 'mr-0',
                        'stage-text',
                      ]"
                      >{{ getStatusTitle(jobAd.status).status }}</span
                    >
                  </div>
                </td>
                <td id="pipeline-statistics">
                  <!-- TODO: integrate custom statistics component -->
                  <!--  <PipelineStats
                :statistics="[{ id: 1, num: 21, label: 'Not contacted' }]"
              ></PipelineStats> -->
                  <ul
                    v-if="jobAd.statistics"
                    class="stats-labels d-none d-sm-none d-xs-none d-md-none d-lg-none d-xl-flex"
                  >
                    <li
                      v-show="
                        jobAd.statistics.not_contacted !== 0 &&
                          jobAd.statistics.not_contacted !== null
                      "
                      class="stats-labels-item color-grey"
                    >
                      <popper
                        :append-to-body="true"
                        trigger="hover"
                        :options="{ placement: 'top' }"
                      >
                        <div class="popper">Not contacted</div>
                        <router-link to slot="reference" class="text-white">{{
                          jobAd.statistics.not_contacted
                        }}</router-link>
                      </popper>
                    </li>
                    <li
                      v-show="
                        jobAd.statistics.contacted !== 0 && jobAd.statistics.contacted !== null
                      "
                      class="stats-labels-item color-light-grey"
                    >
                      <popper
                        :append-to-body="true"
                        trigger="hover"
                        :options="{ placement: 'top' }"
                      >
                        <div class="popper">Contacted</div>
                        <router-link to href slot="reference" class="text-white">{{
                          jobAd.statistics.contacted
                        }}</router-link>
                      </popper>
                    </li>
                    <li
                      v-show="
                        jobAd.statistics.interviewing !== 0 &&
                          jobAd.statistics.interviewing !== null
                      "
                      class="stats-labels-item color-blue"
                    >
                      <popper
                        :append-to-body="true"
                        trigger="hover"
                        :options="{ placement: 'top' }"
                      >
                        <div class="popper">Interviewing</div>
                        <router-link to href slot="reference" class="text-white">{{
                          jobAd.statistics.interviewing
                        }}</router-link>
                      </popper>
                    </li>
                    <li
                      v-show="
                        jobAd.statistics.offered_employment !== 0 &&
                          jobAd.statistics.offered_employment !== null
                      "
                      class="stats-labels-item color-light-blue"
                    >
                      <popper
                        :append-to-body="true"
                        trigger="hover"
                        :options="{ placement: 'top' }"
                      >
                        <div class="popper">Offered employment</div>
                        <router-link to href slot="reference" class="text-white">{{
                          jobAd.statistics.offered_employment
                        }}</router-link>
                      </popper>
                    </li>
                    <li
                      v-show="jobAd.statistics.employed !== 0 && jobAd.statistics.employed !== null"
                      class="stats-labels-item color-green"
                    >
                      <popper
                        :append-to-body="true"
                        trigger="hover"
                        :options="{ placement: 'top' }"
                      >
                        <div class="popper">Employed</div>
                        <router-link to href slot="reference" class="text-white">{{
                          jobAd.statistics.employed
                        }}</router-link>
                      </popper>
                    </li>
                  </ul>
                  <span v-else>N/A</span>
                </td>
              </tr>
            </tbody>
          </table>

          <ErrorList
            class="no-data-message"
            v-show="getJobAds.length == 0"
            name="noJobs"
            :phrase="searchText"
          />
        </div>

        <div class="bottom-controls ml-auto mt-auto w-10">
          <div id="pagination" class="desktop-only">
            <!-- Pagination -->
            <Pagination
              :currentPage="getCurrentPage"
              :totalPages="getTotalPages"
              @nextPage="nextPage"
              @prevPage="previousPage"
              @keyup="keymonitor"
              @selectPageByNumber="setPageBynumber"
              @firstPage="setToFirstPage"
              @lastPage="setToLastPage"
            ></Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { statusMapper /* , redirectToHome */ } from '@/utils/helpers';
import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import { mapGetters, mapActions } from 'vuex';

import Pagination from '@/components/Navigations/Pagination';
// import AddBtn from '../common/TableControlsAddBtn';
import { errorService } from '../../services/errorService';

import Search from '../../components/common/Search/Search';

/* import PipelineStats from '../../common/PipelineStatistics/PipelineStatistics'; */

import { stagesMixin } from '../../mixins/stagesMixin';
import { displayResultsBasedOnScreenHeightMixin } from '../../mixins/displayResultsBasedOnScreenHeightMixin';
import { serviceLevelMixin } from '../../mixins/serviceLevelMixin';

import { localStorageHelper } from '@/utils/helpers';

import ErrorList from '@/components/common/errorsList';

export default {
  props: {
    isVisible: {
      type: String,
      default: '',
    },
  },
  mixins: [stagesMixin, displayResultsBasedOnScreenHeightMixin, serviceLevelMixin],
  components: {
    Pagination,
    Search,
    Sidebar,
    TopNavbar,
    ErrorList,
    /*  PipelineStats, */
  },
  data: () => ({
    /* Filters */
    locationsOptions: [],
    citiesByNameOptions: [],
    selectedFilterName: [],
    filters: [],
    listOfFilters: [],
    /* End Filters */
    stylesObj: {
      boxShadow: '',
    },
    listOfSelectedEmployers: [],
    serviceLevelSelectModel: [],
    searchText: '',
    infiniteScrollList: [],
    toggleFilter: false,
    showModal: false,
    isPublished: '',
    currentPage: 1,
    pageCount: 10,
    isLoading: false,
    promoted: false,
    published: false,
    showLabel: false,
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveCompetencesList',
      'searchLocationByName',
      'retrieveAllCountries',
      'retrieveJobAds',
    ]),
    /* Filters */
    toggleLabel(e) {
      e.target.value ? (this.showLabel = true) : (this.showLabel = false);
    },
    selectedFilterType(e) {
      if (e.target.value == 'distance') {
        this.filters.forEach(el => {
          if (el && Object.keys(el).length === 0) {
            el['distance'] = 100;
            this.showLabel = true;
          }
        });
      }

      if (e.target.value == 'employment') {
        this.filters.forEach(el => {
          if (el && Object.keys(el).length === 0) {
            el['employment'] = '1';
          }
        });
      }

      if (e.target.value == 'relocation') {
        this.filters.forEach(el => {
          if (el && Object.keys(el).length === 0) {
            el['relocation'] = false;
          }
        });
      }
    },
    handleVSelectFields(/* inputValue, filterType */) {
      /* console.log('handleVSelectFields: ', inputValue, filterType); */
    },
    fetchOptions(search, loading) {
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;

            const concatedLists = [].concat(countriesList, citiesList);

            this.locationsOptions = concatedLists;

            loading(false);
          })
          .catch(err => {
            loading(false);
            throw err;
          });
      }
    },
    fetchOptionsForCities(search, loading) {
      if (search.length > 1) {
        loading(true);
        this.searchLocationByName(search)
          .then(response => {
            this.citiesByNameOptions = response.data.cities;

            loading(false);
          })
          .catch(err => {
            loading(false);
            throw err;
          });
      }
    },
    addFilter(_value, fieldType) {
      fieldType.push({});
      this.selectedFilterName.push('location');
    },
    removeSingleFilter(index, fieldType) {
      fieldType.splice(index, 1);
      this.selectedFilterName.splice(index, 1);

      this.reloadDefaultList();
    },
    removeAllFilters() {
      this.filters = [];
      this.selectedFilterName = [];

      this.reloadDefaultList();
    },
    applyFilters() {
      // Remove invalid entries
      this.selectedFilterName.forEach((filterType, index) => {
        if (filterType == 'distance') {
          Object.keys(this.filters[index] || {}).forEach(key =>
            this.selectedFilterName.includes(key),
          );
        } else {
          Object.keys(this.filters[index] || {}).forEach(
            key => this.selectedFilterName.includes(key) || delete this.filters[index][key],
          );
        }
      });

      this.filters.forEach(item => {
        if (item['location']) {
          let tempList = item.location.map(i => i.id);

          this.listOfFilters.push({ location: tempList });

          // Send to API

          console.log('location: ', this.listOfFilters);
        }

        if (item['city']) {
          this.listOfFilters.push({
            distance: {
              city_id: item['city'].id,
              distance: item['distance'] || 0,
            },
          });

          console.log('city: ', this.listOfFilters);
        }

        if (item['employment']) {
          this.listOfFilters.push({
            employment: Number(item.employment),
          });

          console.log('Employment type: ', this.listOfFilters);
        }

        if (item['competences']) {
          this.listOfFilters.push(item);

          console.log('competences: ', this.listOfFilters);
        }

        if (item['relocation'] == true || item['relocation'] == false) {
          console.log('relocation: ', item);

          this.listOfFilters.push({
            relocation: item.relocation,
          });

          console.log('relocation: ', this.listOfFilters);
        }
      });

      console.log('final: ', this.listOfFilters);

      this.doSearchWithFilters(this.listOfFilters);

      //Reset List
      this.listOfFilters = [];
    },
    doSearchWithFilters(filters) {
      this.isLoading = true;
      this.currentPage = 1;

      this.selectedFiltersList = filters;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: filters,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          throw err;
        });
    },
    reloadDefaultList() {
      this.isLoading = true;

      this.selectedFiltersList = [];
      this.currentPage = 1;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        /*  filters: filters, */
        filters: [],
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          if (err.response.status == 401) {
            localStorageHelper();

            this.$toasted.error('Your session is expired!', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });

            this.$router.push({ name: 'home' });
            location.reload();
          }

          this.isLoading = false;
          throw err;
        });
    },
    /* End Filters */
    doSearch(searchedText) {
      console.log('searchedText: ', searchedText);
      this.currentPage = 1;

      if (searchedText.length >= 3) {
        this.isLoading = true;
        this.searchText = searchedText;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: searchedText,
          page: this.currentPage,
          count: this.pageCount,
          published: this.published,
          promoted: this.promoted,
          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }

      if (searchedText === '') {
        this.isLoading = true;
        this.searchText = searchedText;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: searchedText,
          page: this.currentPage,
          count: this.pageCount,
          published: this.published,
          promoted: this.promoted,
          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    infiniteHandler($state) {
      axios
        .get(`http://test4shark.jobshark.se/api/jobadsList`, {
          params: {
            page: this.currentPage,
            count: this.pageCount,
          },
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          console.log(data);
          const list = data.data.result.data;

          if (list.length) {
            this.currentPage += 1;
            this.infiniteScrollList.push(...list);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
    handleSearchFilters() {
      this.isLoading = true;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      console.log(this.published, this.promoted, this.isPublished);

      this.retrieveJobAds({
        page: 1,
        count: this.pageCount,
        /*  employerUuid: this.selectedEmployerUuid, */

        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.filters,
        published: this.published,
        promoted: this.promoted,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          throw err;
        });
      /* else {
        this.retrieveJobAds({
          page: 1,
          count: this.pageCount,
          employerUuid: '',
          optedOut: this.isOptedOut,
        });
      } */
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,

          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
          filters: this.filters,
          published: this.published,
          promoted: this.promoted,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            throw err;
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          published: this.published,
          promoted: this.promoted,
          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
          filters: this.filters,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            throw err;
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.filters,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          throw err;
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }
      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.filters,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          throw err;
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }
      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.filters,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          throw err;
        });
    },
    handleScroll(evt) {
      if (evt.target.scrollLeft > 0) {
        this.stylesObj.boxShadow = 'rgba(0,0,0,0.75) 7px 8px 17px -14px';
      } else {
        this.stylesObj.boxShadow = '';
      }
    },
    getLocation(jobAd) {
      if (jobAd.address) {
        if (jobAd.address.city && jobAd.address.country) {
          return `${jobAd.address.city}, ${jobAd.address.country}`;
        } else {
          return 'N/A';
        }
      }

      return 'N/A';
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    /*  stausFilter(filter) {
      filter.forEach((item) => {
        if (item === 'Promoted') {
          this.promoted = true;
        }

        if (item === 'Published') {
          this.published = true;
        }
      });
    }, */
  },
  watch: {
    showModal() {
      // document.body.style.overflow = this.showModal ? 'hidden' : '';
    },
    serviceLevelSelectModel() {
      const parsed = JSON.stringify(this.serviceLevelSelectModel);
      localStorage.setItem('joblistServiceLevel', parsed);
    },
    listOfSelectedEmployers() {
      const parsed = JSON.stringify(this.listOfSelectedEmployers);
      localStorage.setItem('listOfSelectedEmployers', parsed);
    },
    isPublished() {
      //  localStorage.isPublished = this.isPublished;
    },
  },
  computed: {
    ...mapGetters([
      'getToken',
      'getJobAds',
      'getNextPage',
      'getTotalPages',
      'getUserProfile',
      'getCurrentPage',
      'getCitiesByName',
      'getAllCountries',
      'getEmployersDropdown',
      'getCompetencesFilterList',
    ]),
    getStatus() {
      return statusMapper('6');
    },
  },
  mounted() {
    this.displayResultsBasedOnScreen();

    if (localStorage.joblistServiceLevel)
      this.serviceLevelSelectModel = JSON.parse(localStorage.joblistServiceLevel);

    if (localStorage.listOfSelectedEmployers)
      this.listOfSelectedEmployers = JSON.parse(localStorage.listOfSelectedEmployers);

    if (localStorage.isPublished) this.isPublished = JSON.parse(localStorage.isPublished);

    this.isLoading = true;

    if (this.isPublished.includes('Published')) {
      this.published = true;
    } else {
      this.published = false;
    }

    if (this.isPublished.includes('Promoted')) {
      this.promoted = true;
    } else {
      this.promoted = false;
    }

    this.retrieveJobAds({
      search_word: this.searchText,
      page: 1,
      count: this.pageCount,
      published: this.published,
      promoted: this.promoted,
    })
      .then(() => {
        this.isLoading = false;
      })
      .catch(err => {
        this.isLoading = false;

        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });

        if (err.response.status == 401) {
          localStorageHelper();

          // location.reload();
          this.$router.push({ name: 'home' });
        }
      });

    this.retrieveEmployersDropdown();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins.scss';

.custom-label {
  line-height: 40px;
  position: absolute;
  right: 70px;
  top: 0;
  bottom: 0;
  -moz-transition: 0.3s right ease;
  -ms-transition: 0.3s right ease;
  -o-transition: 0.3s right ease;
  -webkit-transition: 0.3s right ease;
  transition: 0.3s right ease;
  z-index: 0;
}

.btn-success {
  align-self: start;
}

.m-button {
  display: none;
}

.published {
  margin-top: 8px;
}

.truncate-item {
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
}

.custom-table {
  min-width: 100%;
  tr {
    td {
      &:first-of-type {
        padding-left: 21px;
      }
    }
  }
}

.table-responsive {
  overflow-y: auto;
}

select {
  min-width: 110px;
  box-shadow: 0px 2px 3px #0000000d;
  border: 1px solid #d7dae2;
  border-radius: 4px;
}

#stage {
  .stage-size {
    width: 12px;
    height: 12px;
  }

  .stage-color-new {
    background-color: #4ca7d5;
  }
  .stage-color-draft {
    background-color: #8a8b8a;
  }
  .stage-color-active {
    background-color: #419941;
  }
  .stage-color-expired {
    background-color: #f17931;
  }
  .stage-color-rejected {
    background-color: #f02800;
  }
}

/* Pipeline statistics */
#pipeline-statistics {
  position: relative;

  .stats-labels {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(0%, -50%);
    opacity: 0.75;
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-family: Lato;
    font-size: 11px;

    .stats-labels-item {
      span {
        padding: 5px;
        color: #fff;
      }

      // float: left;
      clip-path: polygon(85% 0, 100% 50%, 85% 100%, 0 100%, 10% 50%, 0 0);
      // height: 8px;
      padding: 0.4rem 1rem 0.4rem 1rem;
      margin-right: -10px;
    }

    .color-grey {
      background: #333;
    }

    .color-light-grey {
      background: #747674;
    }

    .color-blue {
      background: #465c74;
    }

    .color-light-blue {
      background: #066da1;
    }

    .color-green {
      background: #148214;
    }

    .color-light-green {
      background: #5bb75b;
    }

    .color-dark-red {
      background: #913d8b;
    }

    .color-red {
      background: #f02800;
    }

    span:nth-child(1) {
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
    }

    span:nth-child(2) {
      font-weight: 300;
    }
  }
}

/* #col-title,
#title:not([data-scroll='0']) {
  -webkit-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
} */
.published-mobile {
  display: none !important;
}

.employer-select {
  flex: 1;
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}
.desktop-only-table {
  display: table;
}
.service-level-select,
.employer-level-select {
  width: 50%;
}

.card {
  height: 81.7vh;
  padding-bottom: 0 !important;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .m-button {
    display: inline-block;
    float: right;
    margin-top: 12px;
  }
  .card {
    margin-top: 26px !important;
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .mobile-only {
    display: block !important;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: block !important ;
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .wrapper {
    width: 100%;
  }
  .service-level-select {
    margin-top: 12px;
  }
  .employer-level-select {
    margin-top: 12px;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    margin-top: 24px !important;
  }
  .mobile-only {
    display: block !important;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: block !important ;
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .service-level-select,
  .employer-level-select {
    width: 100%;
  }
}
@media only screen and (max-width: 576px) {
  .card {
    margin-top: 0px !important;
  }
  .custom-table {
    display: none;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: block !important ;
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .mobile-only {
    display: block !important;
  }
  .service-level-select {
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 1200px) {
  .stats-labels-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.vs--searchable .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px);
}

.col-md-8.filter {
  color: #6c757d;
  margin-bottom: 12px;
  font-family: $font-family-sans-lato;
}

.filter-select {
  min-width: 200px;
  max-width: 200px;
  margin-right: 6px !important;
  padding-bottom: 8px;
}
</style>
